// extracted by mini-css-extract-plugin
export var section = "_2a-1";
export var topNav = "_2a-0";